{
  "error.unauthenticated": "Du behöver logga in för att fortsätta.",
  "error.forbidden": "Du har inte behörighet till det här.",
  "error.not_found": "Vi hittade inte det du sökte.",
  "error.rate_limited": "För många försök. Vänta en stund och försök igen.",
  "error.token_invalid": "Länken fungerar inte. Be om en ny från bekräftelsemejlet.",
  "error.token_expired": "Länken har gått ut. Be om en ny från bekräftelsemejlet.",
  "error.token_already_used": "Länken är redan använd.",
  "error.validation_failed": "Något i formuläret ser inte rätt ut.",
  "error.internal": "Något gick fel hos oss. Försök igen om en liten stund.",
  "error.slot_unavailable": "Tiden är tyvärr inte längre ledig. Välj en annan tid nedan.",
  "error.hold_expired": "Din reservation gick ut. Välj tiden igen så håller vi den i tio minuter.",
  "error.outside_booking_window": "Den tiden går inte att boka. Välj en tid längre fram.",
  "error.too_late_to_cancel": "Det är för sent att ändra bokningen själv. Ring verkstaden så löser vi det.",
  "error.invalid_status_transition": "Bokningen kan inte byta till den statusen.",
  "error.service_unavailable": "Den tjänsten erbjuds inte på den här verkstaden.",
  "error.no_resource_available": "Ingen är ledig för det jobbet just då. Välj en annan tid.",
  "error.outside_service_area": "Adressen ligger utanför verkstadens område.",
  "error.daily_limit_reached": "Verkstaden är fullbokad den dagen. Välj en annan dag.",
  "error.idempotency_key_reused": "Begäran skickades om med ett annat innehåll.",
  "error.storage_unavailable": "Bilduppladdning är inte igång här. Hör av dig till support.",
  "error.resource_in_use": "Det finns kommande bokningar kvar. Flytta över dem först.",
  "error.integration_unavailable": "Google Kalender är inte igång här. Hör av dig till support.",
  "error.integration_handshake_failed": "Kopplingen till Google avbröts. Försök att ansluta igen.",
  "error.product_unavailable": "En eller flera produkter kan inte beställas just nu.",
  "error.workshop_paused": "Verkstaden är pausad och kan inte beställa just nu.",
  "error.address_incomplete": "Leveransadressen saknar gatuadress eller postnummer.",
  "error.outside_working_hours": "Jobbet ryms inte i arbetstiden från den starttiden.",
  "error.email_taken": "E-postadressen används redan av ett annat konto.",
  "error.shared_account": "Personen arbetar även på en annan verkstad. Kontakta HQ för att ändra kontot.",
  "error.owner_exists": "Verkstaden har redan en aktiv ägare."
}
